import { ImageCardProps } from '@backrs_ui/common-ui';

import { useToolCardById } from '@backrs_ui/grow-ui/src/pages/Home/hooks/stickerCardMapping';

import { ToolsSectionParams } from './useGetToolsPageSections';

export const TOOLS_EXPLORE_OPPORTUNITIES_SECTION = ({
  navigate,
}: ToolsSectionParams): ImageCardProps[] => {
  const { getImageCard } = useToolCardById({ navigate });

  return [
    getImageCard('explore_universities_sticker'),
    getImageCard('explore_employers_sticker'),
    getImageCard('discover_jobs_sticker'),
    getImageCard('find_scholarships_sticker'),
    getImageCard('majors_and_courses'),
    getImageCard('jobs_paths_for_you'),
    getImageCard('competency_library'),
  ];
};
